import styled from 'styled-components';
import { Flex, smallBody } from '@ubeya/shared-web/components';

const SettingRow = styled(Flex).attrs(() => ({ className: 'setting-row' }))`
  opacity: ${({ isActive = true }) => (isActive ? 1 : 0.7)};
  pointer-events: ${({ isActive = true }) => (isActive ? 'all' : 'none')};
  display: ${({ isShown = true }) => (isShown ? 'flex' : 'none')};
  flex: 1;
  gap: ${({ $gap }) => $gap || '10'}px;
  margin-left: ${({ $marginLeft }) => $marginLeft || '0'}px;

  min-height: 50px;
  padding: 4px;

  &:has(.error-text-wrapper) {
    margin-bottom: 14px;
  }

  align-items: center;
  > div {
    ${smallBody};

    > span {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export default SettingRow;
